import { FETCH_TRADING_CARDS, ADD_TRADING_CARD, EDIT_TRADING_CARD, DELETE_TRADING_CARD, DESTROY_TRADING_CARD } from '../actionTypes';

export const addTradingCard = teamCard => ({
    type: ADD_TRADING_CARD,
    teamCard
});

export const fetchTradingCards = teamCards => ({
    type: FETCH_TRADING_CARDS,
    teamCards
});

export const editTradingCard = tradingCardView => ({
    type: EDIT_TRADING_CARD,
    tradingCardView
});

export const removeTradingCard = id => ({
    type: DELETE_TRADING_CARD,
    id
});

export const destroyTradingCard = key => ({
    type: DESTROY_TRADING_CARD,
    key
});